import { GetServerSidePropsResult } from 'next';
import { GetServerSideProps } from 'next';
import { NextPage } from 'next';
import React from 'react';
import env from '../../../server/services/env';
import { useResetBreadcrumbs } from '../../components/_shared/Breadcrumbs/BreadcrumbsContext';
import { Auth } from '../../components/Auth';
import { Login } from '../../components/Auth/Login';
import { firstParamValue } from '../../utils/nextRequest';

interface ServerSideProps {
    redirectUrl: string;
}

const LoginPage: NextPage<ServerSideProps> = ({ redirectUrl }) => {
    useResetBreadcrumbs();

    return (
        <Auth activeTab="login">
            <Login redirectUrl={redirectUrl || '/personal'} />
        </Auth>
    );
};

export default LoginPage;

const defaultRedirectUrl = '/personal';
const allowedOrigin = env.ESTP_ORIGIN;

const allowedHost = new URL(allowedOrigin).host;

const getRedirectUrl = (redirectUrl?: string) => {
    try {
        if (redirectUrl) {
            const r = new URL(redirectUrl);
            if (r.host.endsWith(allowedHost)) {
                return r.href;
            }
        }
    } catch (err) {
        // noop
    }
    return defaultRedirectUrl;
};

export const getServerSideProps: GetServerSideProps<ServerSideProps> = async (
    context
): Promise<GetServerSidePropsResult<ServerSideProps>> => {
    const redirectUrl = firstParamValue(
        context.query.backurl || context.query.redirect
    );

    return {
        props: {
            redirectUrl: getRedirectUrl(redirectUrl),
        },
    };
};
